<template>
  <div class="appointment-settings">
    <el-form label-width="120px">
      <el-form-item label="预约时间段">
        <el-select v-model="appointmentSettings.interval" placeholder="请选择">
          <el-option label="30分钟" :value="30"></el-option>
          <el-option label="60分钟" :value="60"></el-option>
          <el-option label="90分钟" :value="90"></el-option>
          <el-option label="120分钟" :value="120"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="最大预约数">
        <el-input-number
            v-model="appointmentSettings.maxAppointments"
            :min="1"
            :max="20"
        ></el-input-number>
      </el-form-item>

      <el-form-item label="可预约时间段">
        <div class="time-slots">
          <div v-for="(day, dayName) in businessHours" :key="dayName" class="day-slots">
            <h4>{{ getDayName(dayName) }}:</h4>
            <div v-if="day.closed" class="closed">休息</div>
            <div v-else class="slot-list">
              <el-tag
                  v-for="slot in generateTimeSlots(day.start, day.end)"
                  :key="slot"
                  type="info"
                  class="time-slot"
              >
                {{ slot }}
              </el-tag>
            </div>
          </div>
        </div>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="saveSettings">保存设置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'AppointmentSettings',
  props: {
    shop: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      appointmentSettings: JSON.parse(JSON.stringify(this.shop.appointmentSettings)),
      businessHours: this.shop.businessHours
    }
  },
  methods: {
    saveSettings() {
      this.$emit('save', this.appointmentSettings)
    },
    getDayName(day) {
      const dayNames = {
        monday: '星期一',
        tuesday: '星期二',
        wednesday: '星期三',
        thursday: '星期四',
        friday: '星期五',
        saturday: '星期六',
        sunday: '星期日'
      }
      return dayNames[day]
    },
    generateTimeSlots(startTime, endTime) {
      if (!startTime || !endTime) return []

      const interval = this.appointmentSettings.interval
      const slots = []
      let current = this.parseTime(startTime)
      const end = this.parseTime(endTime)

      while (current < end) {
        const next = new Date(current.getTime() + interval * 60000)
        if (next > end) break

        slots.push(
            `${this.formatTime(current)} - ${this.formatTime(next)}`
        )
        current = next
      }

      return slots
    },
    parseTime(timeStr) {
      const [hours, minutes] = timeStr.split(':').map(Number)
      const date = new Date()
      date.setHours(hours, minutes, 0, 0)
      return date
    },
    formatTime(date) {
      const hours = date.getHours().toString().padStart(2, '0')
      const minutes = date.getMinutes().toString().padStart(2, '0')
      return `${hours}:${minutes}`
    }
  }
}
</script>

<style scoped>
.appointment-settings {
  padding: 20px;
}

.time-slots {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 15px;
}

.day-slots {
  margin-bottom: 15px;
}

.day-slots h4 {
  margin: 0 0 10px 0;
  font-size: 14px;
  color: #606266;
}

.slot-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.time-slot {
  margin-right: 8px;
  margin-bottom: 8px;
}

.closed {
  color: #f56c6c;
  font-size: 14px;
}
</style>